import ActivationFlow from './components/ActivationFlow';

export default ActivationFlow;
